import { useGrowthbookFeatureValue } from '~/hooks/useGrowthbookFeatureValue';
import { GB_FEATURE_KEYS, GB_FEATURES } from '~/services/abTests/features';

export const useIsHomePageRedesignEnabled = (): boolean => {
  const variant = useGrowthbookFeatureValue(
    GB_FEATURE_KEYS.JUSTDONE_HOME_PAGE_REDESIGN,
  );

  return (
    variant ===
    GB_FEATURES[GB_FEATURE_KEYS.JUSTDONE_HOME_PAGE_REDESIGN].variants.test
  );
};
